import { GET_ESTATES_POPULATE, GET_ESTATES_FIELDS } from '../constants';
import { prepareEstateFilterParams } from '../utils/filters';
import { GET } from '../api';

import type { GetStrapiEstatesResponse } from '../types';

import type { StrapiApiParams } from '@monoimin/sb-types';

export async function getStrapiEstates({
  filters,
  pagination,
  locale = 'en',
  fields = GET_ESTATES_FIELDS,
  populate = GET_ESTATES_POPULATE,
  sort,
}: StrapiApiParams): Promise<GetStrapiEstatesResponse> {
  const { page, pageSize } = pagination || {};

  const queryObject: StrapiApiParams = {
    populate,
    pagination: { page: page ?? 1, pageSize: pageSize || 10 },
    locale,
    fields,
    publicationState: 'live',
    sort,
    filters: prepareEstateFilterParams(filters),
  };

  const { data } = await GET(`/estates`, {
    params: {
      query: queryObject,
    },
  });

  return {
    estates: data?.data ?? [],
    totalCount: data?.meta?.pagination?.total,
    pageCount: data?.meta?.pagination?.pageCount,
  };
}

export default getStrapiEstates;
